import { createSlice } from '@reduxjs/toolkit'
import { setCurrentFilterInfo, setInitialFilterInfo } from '../../../actions'

/* AIRLINES */
export const airlinesFilter = createSlice({
  name: 'airlinesFilter',
  initialState: [],
  reducers: {
    updateAirlineFiltersUI: (state, action) => {
      const { payload = {}, meta = {} } = action.payload
      return state.map((airlineObj) => {
        airlineObj = { ...airlineObj }
        if (meta.isNoneClick) {
          airlineObj.checked = false
        } else if (meta.isAllClick) {
          airlineObj.checked = true
        } else if (meta.isOnlyClick) {
          airlineObj.checked = airlineObj.value === payload.value
        } else {
          airlineObj.checked = airlineObj.value === payload.value ? payload.checked : airlineObj.checked
        }
        return { ...airlineObj }
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase(setInitialFilterInfo, (state, action) => {
      const { payload = {} } = action.payload
      return payload?.AIRLINES || state
    })
    builder.addCase(setCurrentFilterInfo, (state, action) => {
      const { payload = {} } = action
      return payload?.airlinesFilter
    })
  },
})

export const { updateAirlineFiltersUI } = airlinesFilter.actions
